import { PluginComponent } from "@web-noise/core";

const plugin: PluginComponent = {
  type: "sticker",
  audioNode: false,
  node: null,
};

export default plugin;
